<script >/* eslint-disable no-undef */
</script>

<li class="splide__slide" { ...$$props }>
  <slot/>
</li>